import { Ifilter } from "../filter"

export interface IUbicacionRequest extends Ifilter {
    nivel: number
    esCondicion?:boolean
}

export interface IUbicacionCommand {
    nombre: string,
    codigo: string,
    nivel?: number,
    parentId?: string
    
}

export interface IUbicacionCommandEliminar {
    ubicacionId: string
}

export interface IUbicacionDTO {
    ubicacionId: string
    nombre: string
    codigo: string
    nivel: number
    numeracion: number,
    parent?: string
}
export interface IUbicacionCompletoDTO extends IUbicacionDTO{
    esOculto:boolean
}
export interface IUbicacionEdit {
    ubicacionId: string,
    nombre?: string,
    codigo?: string,
    nivel?: number,
    parentId?: string
}

export const initialUbicacionDTO = {
    ubicacionId: "",
    nombre: "",
    codigo: "",
    nivel: 0,
    numeracion: 0
}